import * as React from 'react'

function SvgUsdpLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 160 160"
      fill="currentColor"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.337 137.063C8.23137 121.958 0 101.735 0 80.4004C0 59.0656 8.45384 38.8431 23.337 23.7374C38.4427 8.63176 58.6652 0.400391 80 0.400391C102.002 0.400391 122.002 9.29917 136.663 23.7374C151.769 38.8431 160 59.0656 160 80.4004C160 101.735 151.546 121.958 136.663 137.063C122.225 151.502 102.225 160.4 80 160.4C58.6652 160.4 38.4427 151.947 23.337 137.063Z"
        fill="url(#paint0_linear_9496_506399)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M116.663 42.4029H87.0969V23.0703H72.2136V42.4029H59.5551C52.8811 42.4029 39.7776 47.7422 40.0001 64.4051C40.2226 81.2906 51.9912 85.5175 56.4406 85.5175H72.2136V106.852H42.4472V118.621H72.2136V138.176H87.0969V118.621H98.643C105.54 118.621 119.533 112.837 119.533 96.3962C119.533 80.1782 107.097 74.6165 99.5329 74.6165H86.8744V54.1715H116.418V42.4029H116.663ZM87.0969 85.7399H94.8833C97.7754 85.7399 104.427 86.8523 104.427 96.1737C104.427 105.495 98.4205 106.83 96.1958 106.83H87.0746V85.5175V85.7399H87.0969ZM72.2136 74.8389H64.8722C62.2025 74.8389 54.4383 73.2817 54.4383 64.4051C54.4383 55.5286 60.0001 54.4162 62.0023 54.4162H72.2136V74.8389Z"
        fill="white"
      />
      <path
        d="M87.5418 74.6162H72.4362V85.495H87.5418V74.6162Z"
        fill="#0E9845"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9496_506399"
          x1="18.5969"
          y1="131.896"
          x2="141.253"
          y2="29.016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#024C2A" />
          <stop offset="0.502" stop-color="#0C9943" />
          <stop offset="1" stop-color="#98D435" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SvgUsdpLogo
